<template>
    <div class="dialog" id="delete-member-dialog" aria-hidden="true">
        <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
        <div
            role="dialog"
            class="dialog-content dialog-content--add"
            aria-labelledby="my-dialog-title"
            aria-describedby="my-dialog-description"
        >
            <button
                data-a11y-dialog-hide
                class="dialog-close"
                aria-label="Close this dialog window"
            >
                <img src="@/assets/icons/dialog-close.svg" width="24" height="24" alt="Dialog close" />
            </button>

            <div class="add-form__name">{{$t('project_settings.team.modal.remove_member_title')}}</div>
            <div class="add-form__controls">
                    <span>
                        {{$t('project_settings.team.modal.do_you_want_remove_members')}} <strong>{{memberToDelete.email}}</strong> ?
                    </span>
            </div>
            <div class="dialog__buttons">
                <button class="dialog__button"
                        data-a11y-dialog-hide
                        @click.prevent
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                >{{$t('project_settings.team.modal.cancel')}}</button>
                <button class="dialog__button dialog__button--alt"
                        type="submit"
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                        @click.prevent="submitDeleteClient"
                >
                    <template v-if="!sendingForm">
                        {{$t('project_settings.team.modal.remove')}}
                    </template>
                    <template v-else>
                        {{$t('project_settings.team.modal.removing')}}
                    </template>
                </button>
            </div>
        </div>
    </div>

</template>

<script>
import {inject, onMounted, ref} from "vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
import {useI18n} from "vue-i18n";

export default {
    name: "DeleteProjectMemberModal",
    setup(props,{emit}) {
        const sendingForm = ref(false),
            memberToDelete = ref(''),
            deleteMemberModal = ref(),
            {t} = useI18n();
        let alert = inject('alert'),
            projectId = null;

        onMounted(() => {
            deleteMemberModal.value = new A11yDialog(document.querySelector("#delete-member-dialog"));
        });

        function showModal(memberData = null, projectID = null) {
            if (memberData) {
                memberToDelete.value = memberData;
                projectId = projectID;
            }
            deleteMemberModal.value.show();
        }


        const submitDeleteClient = async () => {
            sendingForm.value = true;
            axios.delete(ApiHelper.getRemoveMemberFromProject(projectId), {
                headers: authHelper.authHeader(),
                data: {
                    email: memberToDelete.value.email
                }
            })
                .then((result) => {
                    sendingForm.value = false;
                    deleteMemberModal.value.hide();
                    emit('updateMember',memberToDelete.value.email);
                    AlertHelper.show(alert,t('project_settings.team.remove_success_title'));
                })
                .catch((error) => {
                    sendingForm.value = false;
                    deleteMemberModal.value.hide();
                    let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
        };

        return {
            memberToDelete,
            showModal,
            sendingForm,
            submitDeleteClient
        }
    }
}
</script>

<style scoped lang="scss">
strong {
    font-weight: 600;
}
.dialog {
    &__button {
        &:hover {
            background: #b9b9b9;
        }
        &--alt {
            background-color: #ff7366;

            &:hover {
                background-color: #e35748;
            }
        }
    }
}
</style>